import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  isOpenFormModal: boolean
  setIsOpenFormModal: (isOpen: boolean) => void
  formType: 'create' | 'edit'
  setFormType: (type: 'create' | 'edit') => void
  isOpenViewModal: boolean
  setIsOpenViewModal: (isOpen: boolean) => void
}

export const SaleOrderViewContext = createContext<IContext>({
  formType: 'create',
  setFormType: () => {},
  isOpenFormModal: false,
  setIsOpenFormModal: () => {},
  isOpenViewModal: false,
  setIsOpenViewModal: () => {},
})

export const SaleOrderViewContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [isOpenFormModal, setIsOpenFormModal] = useState(false)
  const [isOpenViewModal, setIsOpenViewModal] = useState(false)
  const [formType, setFormType] = useState<'create' | 'edit'>('create')

  return (
    <SaleOrderViewContext.Provider
      value={{
        formType,
        setFormType,
        isOpenFormModal,
        setIsOpenFormModal,
        isOpenViewModal,
        setIsOpenViewModal,
      }}>
      {children}
    </SaleOrderViewContext.Provider>
  )
}
